module.exports = __webpack_public_path__ + "static/media/publicsonar_mobility_default.49308a20.svg";